export default __webpack_public_path__ + "static/media/newyear1.fe3d1fea.png";